var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "144px",
    viewBox: "0 0 120 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VECTOR - Objective") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VECTOR---Objective",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4859273,72 C95.7140031,83.0544491 81.9267715,103.639021 70.4859273,113 C59.0450831,122.360979 49.8516222,128.954609 40.4859273,124 C31.1202324,119.045391 67.9604482,93.9709491 60.4859273,73 C57.5501227,64.7631362 52.2486065,67.3874581 45.4859273,63 C35.0309124,56.2170463 19.7510594,48.3580784 20.2524498,35.5441565 C21.0781576,14.4417296 45.2686278,15.7518989 60.481623,18.5547847 C75.6946183,21.3576704 87.6477362,24.3419613 94.4859273,37 C101.324118,49.6580387 101.257851,60.9455509 98.4859273,72 Z",
    id: "Blob",
    fill: "#FDF0E9",
    transform: "translate(60.242964, 71.346857) scale(-1, 1) translate(-60.242964, -71.346857) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sparks",
    transform: "translate(24.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(60.000000, 75.000000)",
    fill: "#FCE8DE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(-0.000000, 89.000000)",
    fill: "#F3B08C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    fill: "#F3B08C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 8,
    y: 0,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 8,
    y: 12,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 8,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 12,
    y: 8,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 8,
    width: 6,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(37.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 40,
    height: 50,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#38627F",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 2,
    y: 2,
    width: 38,
    height: 48,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 16,
    y: 26,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 16,
    y: 30,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 16,
    y: 36,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C9D4DB",
    x: 16,
    y: 40,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "TIck",
    fill: "#F8BC2D",
    points: "8.61945222 32 6 29.4098887 6.77151838 28.647009 8.51709235 30.3730485 11.9571149 26 12.8181818 26.6617523"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "TIck",
    fill: "#F8BC2D",
    points: "8.61945222 42 6 39.4098887 6.77151838 38.647009 8.51709235 40.3730485 11.9571149 36 12.8181818 36.6617523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0242404,9.51880894 L20.2872393,15.7334728 L26.2637381,15.7334728 C26.286292,16.8568776 26.0039393,17.8832306 25.4864584,18.7491852 C24.8749043,19.7725622 23.9367099,20.5703919 22.7972838,21.0426285 C21.6761679,21.5072764 20.4702959,21.6113074 19.3301685,21.3846422 C18.1900412,21.157977 17.1156585,20.6006156 16.2575215,19.7424785 C15.3993844,18.8843415 14.842023,17.8099588 14.6153578,16.6698315 C14.3886926,15.5297041 14.4927236,14.3238321 14.9573715,13.2027162 C15.4220194,12.0816004 16.2015144,11.1556753 17.1682446,10.5101521 C18.0070652,9.95003923 18.986852,9.60103624 20.0242404,9.51880894 L20.0242404,9.51880894 Z",
    id: "Path",
    stroke: "#C80000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,14 L22,8.00000001 C25.2518967,8.14467767 27.8553223,10.7481033 28,14 L22,14 Z",
    id: "Shape",
    fill: "#C80000",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectiveIcon);
export default __webpack_public_path__ + "static/media/objectiveIcon.e6deb213ec3e47df32c6373bbe8334ae.svg";
export { ForwardRef as ReactComponent };